import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import loginPic from '../assets/images/log.svg';
import '../assets/css/Login.css';
import { loginAuth } from '../reducers/AuthSlice';
import { loginSchema } from '../validation/Validate';

const SignIn = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: loginSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setLoading(true);
      try {
        const result = await dispatch(loginAuth(values)).unwrap();
        toast.success('Login successful!');
        localStorage.setItem('token', result.token);
        localStorage.setItem('user', JSON.stringify(result.user));
        localStorage.setItem('loginTime', new Date().toISOString());
        localStorage.setItem('isAuthenticated', 'true');

        if (result.user.role === 'admin') {
          navigate('/');
        } else {
          navigate('/login');
        }
      } catch (error) {
        toast.error(error.message || 'Login failed. Please try again.');
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <div className="containerq">
      <div className="forms-container">
        <div className="signin-signup">
          <form className="sign-in-form" onSubmit={formik.handleSubmit}>
            <h2 className="title">AK Boys Hostel</h2>

            <div className="input-field">
              <i className="fa fa-envelope"></i>
              <input
                type="text"
                placeholder="Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.email && formik.errors.email && (
              <div className="error-message m-0 text-center">{formik.errors.email}</div>
            )}

            <div className="input-field">
              <i className="fa fa-lock"></i>
              <input
                type="password"
                placeholder="Password"
                name="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.password && formik.errors.password && (
              <div className="error-message  m-0 text-center">{formik.errors.password}</div>
            )}

            <div className="text-center d-flex justify-content-end">
              <button
                type="submit"
                className="btn btn-primary text-white"
                disabled={loading}
              >
                {loading ? (
                  <span>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Waiting...
                  </span>
                ) : (
                  'Sign In'
                )}
              </button>
            </div>
            <Link to='/forget-password'>Forget Password?</Link>
          </form>
        </div>
      </div>

      <div className="panels-container">
        <div className="panel left-panel">
          <img src={loginPic} className="image" alt="Login" />
        </div>
      </div>
    </div>
  );
};

export default SignIn;
